/** Renders the agreement content JSON (preamble, sections, signatures, exhibits) in a readable, print-like card. */
export function AgreementText({ content }) {
  const c = content;
  return (
    <article className="rounded-2xl bg-[#F8FAFC] text-slate-900 p-6 sm:p-10 shadow-xl leading-relaxed" data-testid="agreement-text">
      <h2 className="text-center font-bold text-xl sm:text-2xl tracking-wide">{c.title}</h2>
      <p className="text-center text-slate-600 text-sm mt-1 mb-6">{c.subtitle}</p>
      {c.preamble.map((p, i) => <p key={i} className="text-[15px] mb-3">{p}</p>)}
      {c.sections.map((s) => (
        <section key={s.heading} className="mt-5">
          <h3 className="font-bold text-slate-900">{s.heading}</h3>
          {s.clauses.map((cl) => (
            <p key={cl.num} className="text-[15px] mt-2 pl-8 -indent-8"><strong className="mr-2">{cl.num}</strong>{cl.text}</p>
          ))}
        </section>
      ))}
      <p className="text-[15px] mt-6">{c.witness}</p>
      <div className="grid sm:grid-cols-2 gap-6 mt-4">
        {c.signatures.map((s) => (
          <div key={s.role} className="text-[15px]" data-testid={`agreement-sig-${s.role.toLowerCase()}`}>
            <div className="font-bold">{s.role}</div>
            <div>{s.entity}</div>
            <div className="mt-4">By: {s.electronic ? <span className="font-semibold italic text-cyan-700">/s/ {s.name}</span> : <span className="text-slate-400">____________________</span>}</div>
            {s.electronic && <div className="text-xs text-slate-500">Electronically signed {s.signed_at}</div>}
            <div>Name: {s.name}</div>
            <div>Title: {s.title || "______________"}</div>
            <div>Date: {s.signed_at || "______________"}</div>
          </div>
        ))}
      </div>
      {c.exhibits.map((ex) => (
        <section key={ex.heading} className="mt-10 border-t border-slate-300 pt-6">
          <h3 className="font-bold text-lg">{ex.heading}</h3>
          <p className="text-sm text-slate-600 mt-1 mb-3">{ex.intro}</p>
          <table className="w-full text-sm border border-slate-300"><tbody>
            {ex.rows.map(([k, v]) => (
              <tr key={k} className="border-b border-slate-200 align-top">
                <th className="text-left font-semibold bg-slate-100 p-2 w-[38%]">{k}</th>
                <td className="p-2 whitespace-pre-wrap">{v}</td>
              </tr>
            ))}
          </tbody></table>
        </section>
      ))}
    </article>
  );
}
